import{a as t}from"./chunk-PT7GTM3E.js";var e=t({first_stock_price:"date",last_corporate_action:"date",last_stock_price:"date",last_stock_price_adjustment:"date",epsm_inactivity_date:"date"}),r=e;export{e as a,r as b};
